// extracted by mini-css-extract-plugin
export var formContainer = "_if-0";
export var message = "_if-1";